<template>
  <section>
    <!-- Componentes externos -->

    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Programación de vacaciones
    </h3>
    <v-card>
      <v-card-text>
        <strong>NOMBRE: </strong>{{ this.$storage.get("user").nombres }}
        {{ this.$storage.get("user").ap_paterno }}
        {{ this.$storage.get("user").ap_materno }}
        <br />
        <strong>UNIDAD: </strong
        >{{ this.$storage.get("user").unidad[0].nombre_unidad }}

        <crud-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.gestion }}</td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_inicio).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_fin).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_corte).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">{{ items.item.porcentaje }}%</td>

            <td class="nowrap text-xs-center">
              <v-btn
                v-if="gestion_actual != items.item.gestion"
                color="info"
                :to="`vacaciones-aprobar-jefe-superior/${items.item.gestion}`"
                icon
                title="Ver programaciones de vacación"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="gestion_actual == items.item.gestion"
                color="info"
                :to="`vacaciones-aprobar-jefe-superior/${items.item.gestion}`"
                icon
                title="Ver programaciones de vacación"
              >
                <v-icon>list </v-icon>
              </v-btn>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    let user = this.$storage.get("user");
    let id_persona = user.id_persona;

    return {
      url: "programacions",
      graphql: true,
      // Cabecera de la tabla
      initData: [
        {
          state: true,
          param: "restriccion_estados",
          value: `"2,59"`
        }
      ],
      headers: [
        { text: "Gestión", value: "gestion", align: "center" },
        {
          text: "Fecha inicio programación",
          value: "fecha_inicio",
          align: "center"
        },
        { text: "Fecha fin programación", value: "fecha_fin", align: "center" },
        {
          text: "Fecha corte programación",
          value: "fecha_corte",
          align: "center"
        },
        {
          text: "Porcentaje programación",
          value: "porcentaje",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      gestion_actual: new Date().getFullYear() + 1,
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
          id
        gestion
        porcentaje
        fecha_corte
        fecha_inicio
        fecha_fin
        fecha_ampliacion
        id_estado
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [
        // {
        //   field: "gestion",
        //   label: "Gestión",
        //   type: "text", // Tipo de input en el filtro
        //   typeG: "String" // Tipo definido en Graphql
        // },
        // {
        //   field: "estado",
        //   label: "Estado",
        //   type: "text", // Tipo de input en el filtro
        //   typeG: "String" // Tipo definido en Graphql
        // }
      ],
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      nro_item: null,
      persona: null
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    await this.cargarInformacionUsuario();
    //this.onFilter();
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
  },
  // Métodos y funciones del componente
  methods: {
    async cargarInformacionUsuario() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      try {
        let id_item = null;
        let rpta = await this.$service.graphql({
          query: `
						query{
              movilidads(id_persona:${id_persona}){
                rows{
                  id
                  id_persona
                  fecha_incorporacion
                  id_item
                }
              }
            }
					`
        });
        if (rpta.movilidads.rows.length != 0) {
          this.fecha_ingreso = rpta.movilidads.rows[0].fecha_incorporacion;
          id_item = rpta.movilidads.rows[0].id_item;
          //--
          let res = await this.$service.graphql({
            query: `
				query{
                  item(id:${parseInt(id_item)}){
                     id
                     nro_item
                  }
                } 
					`
          });

          if (res.item != 0) {
            this.nro_item = res.item.nro_item;
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  },

  // Definición de componentes importados
  components: {
    CrudTable
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/ListadoGestionesPorUnidad.vue